/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { SupportPlanResponse } from '../types/common/PlanSupport';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SupportPlanApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchSupportPlans = () => {
    return this.api.get<SupportPlanResponse[]>('/support-plans');
  };
}

export const SupportPlanApiService = new SupportPlanApiServiceClass();
